/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg id="Group_2300" data-name="Group 2300" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 32.16 24">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_248" data-name="Rectangle 248" width="32.16" height="24" fill="none" stroke="currentColor" stroke-width="1.3"/>
    </clipPath>
  </defs>
  <path id="Path_1067" data-name="Path 1067" d="M27.164,31.5H21" transform="translate(-7.984 -11.982)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
  <g id="Group_2299" data-name="Group 2299" transform="translate(0)">
    <g id="Group_2298" data-name="Group 2298" clip-path="url(#clip-path)">
      <path id="Path_1068" data-name="Path 1068" d="M12.628,29H2.338A1.338,1.338,0,0,0,1,30.338v.669a2.007,2.007,0,0,0,2.008,2.008H29.776a2.007,2.007,0,0,0,2.008-2.008v-.669A1.338,1.338,0,0,0,30.445,29H20.156" transform="translate(-0.293 -9.593)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
      <path id="Path_1069" data-name="Path 1069" d="M4,17.061V3.008A2.008,2.008,0,0,1,6.008,1H28.761a2.007,2.007,0,0,1,2.008,2.008V8.361" transform="translate(-1.285 -0.331)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
      <path id="Path_1070" data-name="Path 1070" d="M40.7,19.518l-1.431-2.965,2.757-1.428L34.539,10,34,19.284l2.757-1.429,1.376,2.852Z" transform="translate(-11.209 -3.308)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
    </g>
  </g>
</svg>
`

const LaptopSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div dangerouslySetInnerHTML={{ __html: img }} {...props} />
}

export default LaptopSvg
